import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

export default {
  env: process.env.REACT_APP_ENVIRONMENT ? startCase(toLower(process.env.REACT_APP_ENVIRONMENT)) : undefined,
};
